import apiService from './api-service'

const attachmentsService = {}

/**
 * Retrieve an Attachments by it's id
 * @param  array params (optional)
 * @return attachments
 */
attachmentsService.list = function (params) {
  return apiService.get(`/attachment`, { params }).then(res => res.data)
}

/**
 * Retrieve attachments belongs to contract by it's id
 * @param  array params (optional)
 * @return attachments
 */
attachmentsService.fromContract = function (id, params) {
  return apiService.get(`/attachments_contract/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve an Attachments by it's id
 * @param  int id
 * @param  array params (optional)
 * @return attachments
 */
attachmentsService.getById = function (id, params) {
  return apiService.get(`/attachment/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve an Attachment Documents by it's id
 * @param  int id
 * @param  array params (optional)
 * @return attachments url
 */
attachmentsService.getFileUrl = function (id, params) {
  return apiService.get(`/attachment-document/${id}`, { params }).then(res => res.data)
}

/**
 * Retrieve if Attachment is on Monthly Cut
 * @param  int id
 * @param  array params (optional)
 * @return attachments
 */
attachmentsService.checkCuts = function (id, params) {
  return apiService.get(`/monthly+cut/attachment/${id}`, { params }).then(res => res.data)
}

/**
 * Update an Attachment by it's id
 * @param  int id
 * @param  object body
 * @return attachment
 */
attachmentsService.updateById = function (id, body) {
  body['_method'] = 'PUT'
  return apiService.post(`/attachment/${id}`, body).then(res => res.data)
}

/**
 * Cancel an Attachment by it's id
 * @param  int id
 * @param  object body
 * @return attachment
 */
attachmentsService.deleteById = function (id, params) {
  return apiService.put(`/attachment-cancel/${id}`, { params }).then(res => res.data)
}

/**
 * Create an Attachment
 * @param  object body
 * @return attachment
 */
attachmentsService.post = function (body) {
  return apiService.post(`/attachment`, body).then(res => res.data)
}

export default attachmentsService



// WEBPACK FOOTER //
// ./src/services/attachments.js